import { Component, computed, inject, signal } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { of } from 'rxjs';
import { MceApiService } from '../../core/mceapi.client.generated';
import { FormDirective } from '../../shared/directives/form.directive';
import { FormField, form, schema } from '@angular/forms/signals';
export interface StandardsReferenceModel {
  standardGuid: string,
  tableGuid: string,
  htmlContent: string;
}

export const standardsReferenceSchema = schema<StandardsReferenceModel>((path) => {
  // placeholder for future validation
});


@Component({
    selector: 'app-standards-reference',
    imports: [FormField, FormDirective, FormsModule, MatSelectModule, MatCardModule, MatChipsModule, ReactiveFormsModule, MatProgressSpinnerModule],
    templateUrl: './standards-reference.component.html',
    styleUrl: './standards-reference.component.scss'
})
export class StandardsReferenceComponent {

  private mceApiService = inject(MceApiService);

  protected readonly formValid = signal<boolean>(false);
  protected readonly formDirty = signal<boolean>(false);

  readonly standardsReferenceModel = signal<StandardsReferenceModel>({
    standardGuid: '',
    tableGuid: '',
    htmlContent: ''
  })
  readonly standardsReferenceForm =
    form<StandardsReferenceModel>(this.standardsReferenceModel, standardsReferenceSchema);

  // Reference standards
  standardsResource = rxResource({
    stream: () => this.mceApiService.v1StandardsReference()
  });
  standards = computed(() => this.standardsResource.value() ?? []);

  // Tables for selected standard
  tablesResource = rxResource({
    params: () => ({ standard: this.standardsReferenceForm().value().standardGuid }),
    stream: ({ params }) => {
      if (params.standard === '') return of([]);
      return this.mceApiService.v1StandardsReferenceTables(params.standard);
    }
  });
  tables = computed(() => this.tablesResource.value() ?? []);

  // Data for selected table
  tableDataResource = rxResource({
    params: () => ({ table: this.standardsReferenceForm().value().tableGuid }),
    stream: ({ params }) => {
      if (params.table === '') return of({ html: '' });
      return this.mceApiService.v1StandardsReferenceHTML(params.table);
    }
  });
  tableData = computed(() => this.tableDataResource.value() ?? { html: '' });
}
